const SECTION_NODES = new Set(['contentPageSection', 'planVanAanpakSection']);
const ATOM_NODES_WITH_CONTENT_LOGO = new Set([
  'coverBlock',
  'teamBlock',
  'signaturePageBlock',
]);
/** investmentHeaderNode is atom; investmentGroupNode moet true returnen zodat geneste headers ook clientLogoUrl krijgen. */

/**
 * Propagates a client logo URL to every node in the document that supports it,
 * except the source node itself.
 */
export function propagateClientLogo(
  editor: { state: { doc: any; tr: any }; view: { dispatch: (tr: any) => void }; chain: () => any },
  sourceNode: any,
  logoUrl: string,
): void {
  const { tr } = editor.state;
  let changed = false;

  editor.state.doc.descendants((child: any, pos: number) => {
    if (child === sourceNode) return false;
    const name = child.type.name;

    if (SECTION_NODES.has(name)) {
      tr.setNodeMarkup(pos, undefined, { ...child.attrs, clientLogoUrl: logoUrl });
      changed = true;
      return false;
    }

    if (name === 'investmentGroupNode') {
      tr.setNodeMarkup(pos, undefined, { ...child.attrs, clientLogoUrl: logoUrl });
      changed = true;
      return true;
    }

    if (name === 'investmentHeaderNode') {
      tr.setNodeMarkup(pos, undefined, { ...child.attrs, clientLogoUrl: logoUrl });
      changed = true;
      return false;
    }

    if (ATOM_NODES_WITH_CONTENT_LOGO.has(name)) {
      const content = (child.attrs.content as Record<string, unknown>) ?? {};
      tr.setNodeMarkup(pos, undefined, {
        ...child.attrs,
        content: { ...content, clientLogoUrl: logoUrl },
      });
      changed = true;
      return false;
    }

    return true;
  });

  if (changed) {
    editor.view.dispatch(tr);
  }
}
